import { IdToken, useAuth0 } from "@auth0/auth0-react";
import { useCallback, useEffect, useState } from "react";

const useIdToken = () => {
  const [idToken, setIdToken] = useState<IdToken | undefined>(undefined);

  const { getIdTokenClaims } = useAuth0();

  const getIdToken = useCallback(async () => {
    setIdToken(await getIdTokenClaims());
  }, [getIdTokenClaims]);

  useEffect(() => {
    getIdToken();
  }, [getIdToken]);

  return idToken;
};

export default useIdToken;
